import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    flashMessages: {}
};


const flashMessages = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_FLASH_MESSAGES_LIST: {
      draft.flashMessages = payload?.flashMessages;
      break;
    }
    case Actions.SELECTED_FLASH_MESSAGE_ID: {
      draft.selectedFlashMessageId = payload?.selectedFlashMessageId;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default flashMessages;
